import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import platformAPI from "../../../services/platformApi";
import { buildClinicPortalUrl } from "../../../utils/portalHost";
import s from "./platformAdmin.module.css";

const STATUS_LABEL = {
  trial: "Пробный",
  active: "Активен",
  suspended: "Отключён",
};

function formatRub(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

export default function PlatformTenants() {
  const [clinics, setClinics] = useState([]);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");

  const load = () => {
    platformAPI
      .getClinics()
      .then((r) => setClinics(r.clinics || []))
      .catch((e) =>
        setErr(e.response?.data?.error || "Ошибка загрузки клубов"),
      );
  };

  useEffect(() => {
    load();
  }, []);

  const setStatus = async (id, status) => {
    try {
      await platformAPI.updateClinicStatus(id, status);
      setMsg("Статус обновлён");
      load();
    } catch (e) {
      setErr(e.response?.data?.error || "Ошибка");
    }
  };

  return (
    <>
      <div className={s.topbar}>
        <div>
          <h1 className={s.title}>Клубы</h1>
          <p className={s.subtitle}>Все клиенты платформы BaySport</p>
        </div>
      </div>

      {msg ? <div className={s.alertSuccess}>{msg}</div> : null}
      {err ? <div className={s.alertError}>{err}</div> : null}

      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Клуб</th>
              <th>Поддомен</th>
              <th>Тариф</th>
              <th>Статус</th>
              <th>Тренеры</th>
              <th>Клиенты</th>
              <th>Выручка 30д</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {clinics.map((c) => (
              <tr key={c.id}>
                <td>
                  <Link to={`/admin/tenants/${c.id}`}>{c.name}</Link>
                </td>
                <td>
                  <a
                    href={buildClinicPortalUrl(c.subdomain, "/manage")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {c.subdomain}
                  </a>
                </td>
                <td>{c.plan?.name || c.plan_tier || "—"}</td>
                <td>{STATUS_LABEL[c.status] || c.status}</td>
                <td>{c.stats?.trainers ?? 0}</td>
                <td>{c.stats?.clients ?? 0}</td>
                <td>{formatRub(c.stats?.revenue_30d)} ₽</td>
                <td>
                  <select
                    value={c.status}
                    onChange={(e) => setStatus(c.id, e.target.value)}
                  >
                    <option value="trial">trial</option>
                    <option value="active">active</option>
                    <option value="suspended">suspended</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
